import { DialogOverlay, DialogContent } from '@reach/dialog';
import '@reach/dialog/styles.css';
import ButtonClose from '@remote-com/mushu/src/components/Ui/Button/ButtonClose';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ModalOverlay = styled(DialogOverlay)`
  position: fixed;
  z-index: 10; // Observed issue when used in page containing element with z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(23, 18, 55, 0.6);
  overflow-y: auto;
  overflow-x: hidden;
`;

const ModalArea = styled.div`
  position: relative;
  width: auto;
  max-width: 620px;
  min-height: calc(100% - 100px); /* 100px = 50px * 2 margin */
  margin: 50px auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContent = styled(DialogContent)`
  outline: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  color: var(--colors-bayoux);
  box-shadow: 0 12px 48px rgba(96, 101, 123, 0.24);
  --modalRadius: 10px;
  border-radius: var(--modalRadius);
  /* Do not add overflow:hidden to allow content to go over the edge (eg dropdowns) */

  /** override reach-ui */
  /** Use && because of SC SSR Bug */
  && {
    width: 100%;
    background: transparent;
    margin: 0;
    padding: 0;
  }
`;

export const ButtonCloseStyled = styled(ButtonClose)`
  position: absolute;
  color: var(--colors-bayoux);
  top: 10px;
  right: 16px;
`;

const Body = styled.div`
  background-color: var(--colors-blank);
  border-radius: var(--modalRadius);
`;

const Modal = ({
  children,
  visible,
  onCancel,
  onClose = onCancel,
  'data-testid': dataTestid,
  headerTitle,
  className, // pass styled component classes down
  bodyStyle,
  closeButtonProps,
}) => {
  const modalAriaTitle = headerTitle
    ? { 'aria-labelledby': '#modalTitle' }
    : { 'aria-label': 'Dialog area' };

  return (
    visible && (
      <ModalOverlay
        isOpen={visible}
        onDismiss={onClose}
        data-testid={dataTestid}
        className={className}
      >
        <ModalArea style={bodyStyle ?? {}}>
          <ModalContent {...modalAriaTitle}>
            <ButtonCloseStyled aria-label="Close Modal" onClick={onClose} {...closeButtonProps} />
            <Body>{children}</Body>
          </ModalContent>
        </ModalArea>
      </ModalOverlay>
    )
  );
};

/* eslint-disable react/default-props-match-prop-types */
Modal.defaultProps = {
  visible: false,
  formName: '',
  // eslint-disable-next-line react/default-props-match-prop-types
  'data-testid': 'modal', // dunno why the lint error happens
};

export const modalPropTypes = {
  /** Controls modal visibility (if false it is not rendered) */
  visible: PropTypes.bool,
  /** Passed to submit button if shouldSubmit is tru */
  formName: PropTypes.string,
  onCancel: PropTypes.func,
};

Modal.propTypes = {
  ...modalPropTypes,
  children: PropTypes.node.isRequired,
};
export { Modal };
export default Modal;
